import React, { useEffect, useState } from "react";
import EmployeesSapTable from "./components/EmployeesSapTable";
import FilterSap from "./modals/FilterSap";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { updateObject } from "../../../helpers/updateObject";
import View from "./modals/ViewSap";
import Divider from "@material-ui/core/Divider/index";
import ReactDatePicker from "../UI/ReactDatePicker2";
import ExportIcon from "@material-ui/icons/CloudDownload";


function EmployeesSap(props) {
  const [showView, setShowView] = useState(false);
  const [saps, setSaps] = useState([]);
  const [chooseSapId, setChooseSapId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteSapsIds, setDeleteSapsIds] = useState([]);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  var date = new Date();

  const [filterInputs, setFilterInputs] = useState({
    deviceId: "",
    devicePlaceId: "",
    pin: "",
    status: "",
    structureId: "",
    surname: "",
    middleName: "",
    name: "",
    start: new Date(
      new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0) -
      new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T").join(" ").split(".")[0],


    end: new Date(
      new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999) - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T").join(" ").split(".")[0],
  });

  function handleChange() {
    setShowFilter((key) => !key);
  }
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  const onSaps = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      deviceId,
      devicePlaceId,
      middleName,
      name,
      pin,
      status,
      start,
      surname,
      structureId,
      end
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}biometric/logs?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}&source=SAP${deviceId ? `&deviceId=${deviceId}` : ""}${devicePlaceId ? `&devicePlaceId=${devicePlaceId}` : ""}${end ? `&end=${end}` : ""}${middleName ? `&middleName=${middleName}` : ""}${name ? `&name=${name}` : ""}${pin ? `&pin=${pin}` : ""}${start ? `&start=${start}` : ""}${status ? `&status=${status}` : ""}${structureId ? `&structureId=${structureId}` : ""}${surname ? `&surname=${surname}` : ""}`,)
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
       
        setSaps(content)

        setIsError(false);
        setCount(totalElements)
      })
      .catch(() => {
        setIsLoading(false);
        setSaps([]);
        setIsError(true);
      });
  };

  const onBiometricLogFilterExport = () => {

    axios
      .get(`${process.env.REACT_APP_API_URL}biometric/logs/excel?${filterInputs.deviceId ? `&deviceId=${filterInputs.deviceId}` : ""}${filterInputs.devicePlaceId ? `&devicePlaceId=${filterInputs.devicePlaceId}` : ""}${filterInputs.end ? `&end=${filterInputs.end}` : ""}${filterInputs.middleName ? `&middleName=${filterInputs.middleName}` : ""}${filterInputs.name ? `&name=${filterInputs.name}` : ""}${filterInputs.pin ? `&pin=${filterInputs.pin}` : ""}&source=SAP${filterInputs.start ? `&start=${filterInputs.start}` : ""}${filterInputs.status ? `&status=${filterInputs.status}` : ""}${filterInputs.structureId ? `&structureId=${filterInputs.structureId}` : ""}${filterInputs.surname ? `&surname=${filterInputs.surname}` : ""}`,

        {
          responseType: "blob",

        }
      ).then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Biometric-log.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };


  const onSapChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}biometric/logs/${id}`,);
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onSaps(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);



  const [structureId, setStructureId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP`)
      .then((res) => {
        const structureId = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setStructureId(structureId);
      });
  }, []);


  const [devicePlaceId, setDevicePlaceId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}devicePlace`)
      .then(({ data: { content } }) => {
        const models = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDevicePlaceId(models);
      });
  }, []);

  const [deviceId, setDeviceId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}device/select`)
      .then(({ data }) => {
        const models = data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDeviceId(models);
      });
  }, []);


  return (
    <div className="row bg-white rounded SHADOW">
      <div className=" row mb-0 d-flex w-100 justify-content-end">

        <div className=" col-2 timeInterval">
          <ReactDatePicker
            id="start"
            name="start"
            label="Başlama tarixi"
            filterInputsUpdateKey={filterInputsUpdate}
            value={new Date(filterInputs.start)}
          />

        </div>
        <div className="col-2 timeInterval">
          <ReactDatePicker
            id="end"
            name="end"
            label="Bitmə tarixi"
            filterInputsUpdateKey={filterInputsUpdate}
            showTime={false}
            value={new Date(filterInputs.end)}
          />
        </div>
        <div className=" col-3 d-flex justify-content-end">
          <FormControlLabel
            control={
              <Switch
                checked={showFilter}
                onChange={handleChange}
                color="secondary"
              />
            }
            label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
            className="ml-auto mb-0"
          />
        </div>
        <div className=" col-1 d-flex justify-content-end"><button
          className="btn btn-sm btn-icon btn-bg-light btn-text-success btn-hover-success mr-2 h5 rounded-circle flex-shrink-0"
          onClick={onBiometricLogFilterExport}
        >
          <ExportIcon />
        </button>
        </div>
      </div>
      <Divider className="w-100" />

      <EmployeesSapTable
        saps={saps}
        isLoading={isLoading}
        isError={isError}
        setDeleteSapsIds={setDeleteSapsIds}
        deleteSapsIds={deleteSapsIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setChooseSapId={setChooseSapId}
        setOpenView={toggleDrawer(true)}
        onBiometricLogFilterExport={onBiometricLogFilterExport}
      />
     
      <FilterSap
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        structureId={structureId}
        devicePlaceId={devicePlaceId}
        deviceId={deviceId}

      />


      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onSapChoose={onSapChoose}
          chooseSapId={chooseSapId}
        />
      )}

    </div>
  );
}

export default EmployeesSap;
